<template>
  <div class="flex items-center" :class="{ 'w-full': toggleText }">
    <label
      class="relative inline-block w-12 h-6 gd-toggle-switch cursor-pointer"
      :class="{ active: value }"
      @click="toggle"
    >
      <span
        class="absolute inset-0 rounded-full"
        :class="{
          'bg-pink': value,
          'bg-grey-100': !value && !hasState('dark'),
          [darkBgClass]: !value && hasState('dark'),
        }"
      ></span>
    </label>
    <span v-if="toggleText" :class="toggleTextClasses || 'text-white mx-2'">{{
      toggleText
    }}</span>
  </div>
</template>

<script>
import mixins from '../mixins';

export default {
  name: 'GdToggle',
  mixins: [mixins],
  props: {
    value: {},
    dark: {},
    toggleText: {},
    toggleTextClasses: {},
    darkBgClass: {
      default: 'bg-grey-800'
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
      this.$emit('change', !this.value);
    },
  },
};
</script>
